import axios from "../plugins/axios";

// Each function owns its own cancel token. They are independent calls: a
// getAll() must never cancel an in-flight getAllGrouped() (or vice versa),
// which previously rejected the other request and left the store stuck on
// its loading flag. Cancelling this function's OWN previous request is
// still intended.
let getAllCancelSource = null;
let getAllGroupedCancelSource = null;

async function getAll(payload) {
  if (getAllCancelSource) {
    getAllCancelSource.cancel("previous request canceled");
  }

  const source = axios.CancelToken.source();
  getAllCancelSource = source;

  try {
    const res = await axios.get(`/qr-app/product`, {
      params: payload,
      cancelToken: source.token,
    });
    return res.data;
  } finally {
    // Only clear if a newer request has not already taken over.
    if (getAllCancelSource === source) {
      getAllCancelSource = null;
    }
  }
}

async function getAllGrouped(payload) {
  if (getAllGroupedCancelSource) {
    getAllGroupedCancelSource.cancel("previous request canceled");
  }

  const source = axios.CancelToken.source();
  getAllGroupedCancelSource = source;

  try {
    const res = await axios.get(`/qr-app/product`, {
      params: { menu_id: payload.menu_id },
      cancelToken: source.token,
    });
    return res.data;
  } finally {
    // Only clear if a newer request has not already taken over.
    if (getAllGroupedCancelSource === source) {
      getAllGroupedCancelSource = null;
    }
  }
}

// The grouped menu again, for a background refresh or the cart's availability
// check. A third, independent token: neither of those may cancel the Menu
// page's own load (or be cancelled by it), so it cannot share
// getAllGroupedCancelSource. `timeout` (ms) is passed straight to axios.
let getGroupedSilentCancelSource = null;

async function getGroupedSilent(payload, options = {}) {
  if (getGroupedSilentCancelSource) {
    getGroupedSilentCancelSource.cancel("previous request canceled");
  }

  const source = axios.CancelToken.source();
  getGroupedSilentCancelSource = source;

  try {
    const res = await axios.get(`/qr-app/product`, {
      params: { menu_id: payload.menu_id },
      cancelToken: source.token,
      timeout: options.timeout || 0,
    });
    return res.data;
  } finally {
    if (getGroupedSilentCancelSource === source) {
      getGroupedSilentCancelSource = null;
    }
  }
}

const productService = {
  getAll,
  getAllGrouped,
  getGroupedSilent,
};

export default productService;
